import { render, staticRenderFns } from "./GroupSessionInvitationDeclineNotification.vue?vue&type=template&id=3706515f&scoped=true&"
import script from "./GroupSessionInvitationDeclineNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionInvitationDeclineNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3706515f",
  null
  
)

export default component.exports